import React, { FC, useState } from "react";
import Dialog from "../../dialog";
import {
  IconBackground,
  ModalWrapper,
  HeadWrapper,
  BodyModal,
  GreyText,
  Icon,
  WarningBlock,
} from './styles'
import { icons } from "../../../icons";
import Typography from "../../typography";
import Button from "../../button";
import { useTranslation } from "react-i18next";
import AuthImage from './google-authenticator.svg'
import CheckBox from "../../checkbox";
import { BodySmall } from "../../typography/styled";
import Warning from '../../alert/warning.svg'
import { authService } from "../../../api";
import { useUi } from "../../../context/ui.context";

type ModalProps = {
  closeModalCancel:() => void;
  closeModal:() => void;
}  


const RegenerateWarning:FC<ModalProps> = (props) => {
  const [sure, setSure] = useState<boolean>(false)
  const {
    closeModalCancel,
    closeModal,
  } = props
  const {viewAlert} = useUi()
  const refreshCode = () => {
    authService.regenerateCode()
    .then((res:any) => {
      closeModal()
    })
    .catch((e) => {
      if(e.response.data.detail){
        viewAlert({
          severity:'error',
          message:e.response.data.detail,
        })
      }
    })
  }
  const [t] = useTranslation()
  return(
    <ModalWrapper sure={sure}>
      <HeadWrapper>
        <Icon 
          onClick={closeModalCancel}
          src={icons.CloseIcon}/>
      </HeadWrapper>
      <BodyModal>
        <IconBackground>
          <img style={{width:'50px', height:'50px'}} src={AuthImage}/>
        </IconBackground>
        <Typography variant='h3'>
          {t("REGENERATE_CODE")}
        </Typography>
        <GreyText>
          {t("ARE_YOU_SURE")}
        </GreyText>
        <div style={{width:'100%', display:'flex', alignItems:'flex-start'}}>
          <CheckBox
            customStyles={{marginTop:'2px'}}
            value={sure}
            withoutText
            onChange={() => setSure(!sure)}
            toolTip={false}
            title={''}
          />
          <Typography variant="body">
            {t("REGENERATE_INFO")}
          </Typography>
        </div>
        {sure ? 
          <WarningBlock>
            <img src={Warning}/>
            <BodySmall style={{color:"#1E1E1E"}}>
              {t("REGENERATE_INFO_WARNING")}
            </BodySmall>
          </WarningBlock>
        : null}
        <div style={{display:"flex", gap:'6px', marginTop:'30px'}}>
          <Button
            variant="stroke"
            size="display"
            customStyles={{ width: '157px', justifyContent:'center' }}
            onClick={closeModalCancel}
            title={t("NO")}
          />
          <Button
            variant="primary"
            size="display"
            disabled={!sure}
            customStyles={{ width: '157px', justifyContent:'center' }}
            onClick={refreshCode}
            title={t("YES")}
          />
        </div>
      </BodyModal>
    </ModalWrapper>
  )
}

export default RegenerateWarning